import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Observable';

import {Company} from 'shared/models/target-groups/company';
import {CompaniesRepository} from '../repositories/companies.repository';

@Injectable()
export class CompaniesService {

  constructor(private companiesRepository: CompaniesRepository) { }

  public getAllCompanies(): Observable<Array<Company>> {
    return this.companiesRepository.getAllCompanies();
  }

  public getAllCompaniesUsersCnt(): Observable<Array<any>> {
    return this.companiesRepository.getAllCompaniesUsersCnt();
  }

  public getCompany(id: string): Observable<Company> {
    return this.companiesRepository.getCompany(id);
  }

  public createCompany(newCompanyName: string): Observable<Company> {
    const newCompany: Company = {
      name: newCompanyName,
    };

    return this.companiesRepository.createCompany(newCompany);
  }

  public updateCompany(company: Company): Observable<Company> {
    return this.companiesRepository.updateCompany(company);
  }

  public deleteCompany(company: Company): Observable<boolean> {
    return this.companiesRepository.deleteCompany(company);
  }


  public getUsersExport(company: Company): Observable<Blob> {
    return this.companiesRepository.getUsersExport(company);
  }

}



// WEBPACK FOOTER //
// /usr/src/app/src/app/modules/target-groups/companies/services/companies.service.ts